
export class ValidatorConstants {

    public static PHONE_NUMBER_REGEX = "^(?!\\b(0)\\1+\\b)(\\+?\\d{1,3}[. -]?)?\\(?\\d{3}\\)?([. -]?)\\d{3}\\3\\d{4}$";
}
